export const EMPTY_WORD_INDEX = -1;